enum ListingType {
  Auction = "Auction",
  InstantSale = "InstantSale",
}

export default ListingType;
